import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getAuthor, getBooks, getReviews, getGallery, getVideos, getBlog, getMedia, getStats } from '../utils/api';

const SiteDataContext = createContext();

export const useSiteData = () => {
  const ctx = useContext(SiteDataContext);
  if (!ctx) throw new Error('useSiteData must be used within SiteDataProvider');
  return ctx;
};

export const SiteDataProvider = ({ children }) => {
  const [data, setData] = useState({
    author: null,
    books: [],
    reviews: [],
    gallery: [],
    videos: [],
    blog: [],
    media: [],
    stats: { readers: 50000, reviews: 1200, events: 150, rating: 4.8 },
  });
  const [loading, setLoading] = useState(true);

  const fetchAll = useCallback(async () => {
    try {
      const [author, books, reviews, gallery, videos, blog, media, stats] = await Promise.all([
        getAuthor().catch(() => null),
        getBooks().catch(() => []),
        getReviews().catch(() => []),
        getGallery().catch(() => []),
        getVideos().catch(() => []),
        getBlog().catch(() => []),
        getMedia().catch(() => []),
        getStats().catch(() => ({ readers: 50000, reviews: 1200, events: 150, rating: 4.8 })),
      ]);
      setData({ author, books, reviews, gallery, videos, blog, media, stats });
    } catch (e) {
      console.error('Failed to fetch site data', e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  return (
    <SiteDataContext.Provider value={{ ...data, loading, refresh: fetchAll }}>
      {children}
    </SiteDataContext.Provider>
  );
};
